import { useEffect } from "react";
import { localStorageItem } from "../modules/utils/localStorage";
import { KEY_LOCALSTORAGE } from "../modules/auth/core/_consts";

const RedirectToClientAdmin  = () => {
  useEffect(() => {
    window.location.href = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["oauthClientUrl"] || process.env.REACT_APP_HOME_CLIENT;
  }, []);

  return null;
};

export default RedirectToClientAdmin ;
